import React from "react";
import { useParams } from "react-router-dom";
import TopBar from "../components/TopBar";

// Stand-in for bottom-bar tabs that aren't built on the web yet (Recurring,
// Chat, Stats, Invoice). Only Tasks and Settings are wired to real screens for
// now; the rest land here.
const TITLES = {
  recurring: "Recurring",
  chat: "Chat",
  stats: "Stats",
  invoice: "Invoice",
};

const PlaceholderScreen = () => {
  const { feature } = useParams();
  const title = TITLES[feature] || "Coming soon";

  return (
    <div style={{ paddingTop: "50px" }}>
      <TopBar title={title} />
      <div style={styles.body}>
        <div style={styles.title}>{title}</div>
        <div style={styles.subtitle}>Coming soon to the web.</div>
      </div>
    </div>
  );
};

const styles = {
  body: {
    padding: "64px 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    textAlign: "center",
  },
  title: { color: "var(--text)", fontSize: "22px", fontWeight: "bold" },
  subtitle: { color: "var(--text-muted)", fontSize: "15px" },
};

export default PlaceholderScreen;
